import React,{useState} from "react";
import { Link } from "react-router-dom";

import bg1 from "../assets/images/bg/words-of-encouragement1.webp"
import about from "../assets/images/about.jpg"
import cta from "../assets/images/cta.jpg"

import NavbarTwo from "../components/navbar/navbarTwo"
import ClientTwo from "../components/client/clientTwo";
import Partners from "../components/partners";
import Team from "../components/team";
import FooterThree from "../components/footer/footerThree";
import ScrollTop from "../components/scrollTop";
import { HashLink } from 'react-router-hash-link';
import { scrollWithOffset } from "../utils/scrollUtils";

import ModalVideo from 'react-modal-video';
import '../../node_modules/react-modal-video/css/modal-video.css';

import {AiOutlineCheckCircle, FiAirplay, LiaReact, FiUsers,FiArrowRight} from '../assets/icons/vander'
import CountUp from 'react-countup';

export default function AboutUs(){
    return (
        <>
        <NavbarTwo navClass="defaultscroll sticky" manuClass="navigation-menu nav-right nav-light"/>

        <section id="page-top" className="bg-half-170 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="bg-overlay bg-gradient-overlay"></div>
            <div className="container">
                <div className="row mt-5 justify-content-center">
                    <div className="col-12">
                        <div className="title-heading text-center">
                            <h5 className="heading fw-semibold mb-0 page-heading text-white title-dark">Words of Encouragement for People in Debt</h5>
                            <small className="text-white-50 mb-1 fw-medium text-uppercase mx-auto">A message for anyone digging their way out of financial struggle</small>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="section-title">
                            <div className="text-muted2">
                                <p><strong>To the one feeling buried in debt…</strong></p>

                                <p>Take a breath. This is not the end of your story.</p>

                                <p>You are not your debt. You're not defined by a number on a statement or the mistakes (or circumstances) that got you here. Debt happens to good, hardworking people who were just trying to make life work. You’re not alone in this, and more importantly, you’re not stuck. You’re simply in the middle of a comeback story.</p>

                                <h4>1. You’re not failing, you’re learning.</h4>
                                <p>Every late payment, every overdraft, every credit card swipe that haunts you, it’s data. Not defeat. Use it. Learn from it. Build a strategy with it. No one climbs out of a hole by staring at the dirt. Budgeting, planning, and discipline are your handholds. Grab them.</p>

                                <h4>2. Progress beats perfection. Every. Single. Time.</h4>
                                <p>You don’t need to knock out $30,000 in debt tomorrow. What you do need is to make the next right financial decision. And then the one after that. Maybe that’s cooking at home instead of eating out. Maybe it’s holding off on the trade up on your phone. Those little moves? They compound. They build. They matter.</p>

                                <h4>3. You’re allowed to feel overwhelmed but don’t stay there.</h4>
                                <p>Debt can make you feel ashamed, panicked, or numb. That's human. But don’t stay in that headspace. Shake it off. You’ve got goals. You’ve got grit. And you’ve got what it takes to fight your way out of debt, one step at a time.</p>

                                <h4>4. Self-discipline isn’t punishment, it’s self-respect.</h4>
                                <p>Saying no now so you can say yes later is one of the most powerful things you’ll ever do. Cutting back, budgeting, working an extra shift. You’re trading temporary comfort for long-term peace. And that’s a trade worth making.</p>

                                <ul><li><b>Pro Tip:</b> If you can help it, NEVER take a cash advance against your credit cards. Cash advances come with an interest rate that can be much higher than your normal rate for purchases. Additionally, some cards will require you to pay off your purchase balance BEFORE they will start applying funds to your cash advance balance.  They are evil, seriously. Oh, and this includes those handy little checks they send you with your bill.  Buy something with one of those suckers and you just initiated a cash advance.  Rip them up.  </li></ul>

                                <h4>5. You have more control than you think.</h4>
                                <p>The world wants you to believe you’re powerless. Credit card companies profit from that lie. But the truth? You’re in the driver’s seat. Every payment you make, every dollar you track, every financial win. It puts you back in control. Even if it’s slow. Even if it’s hard.</p>

                                <h4>6. You’re modeling resilience.</h4>
                                <p>If you’ve got kids, a partner, friends watching, they’re seeing you rise. They’re seeing how to handle hard things without quitting. You're building your legacy. That’s powerful.</p>

                                <h4>7. Celebrate the crap out of the small wins.</h4>
                                <p>Paid off a credit card? Dance in your kitchen. Saved $100? Write it on the fridge. Every win matters. Every milestone proves you're not where you were and that deserves celebration.</p>

                                <hr />

                                <h4>Final word?</h4>
                                
                                <p><strong>You’ve got this.</strong></p>

                                <p>And if you ever feel like you don’t, read this again. Because one day soon, you’re going to be the one encouraging someone else… from the other side of it.</p>

                                <p><strong>Let’s go. 💪</strong></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterThree/>
        <ScrollTop/>
        </>
    )
}